import { render } from "./productDetailsForm.vue?vue&type=template&id=26ee1a16&scoped=true"
import script from "./productDetailsForm.vue?vue&type=script&lang=js"
export * from "./productDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ee1a16"]])

export default __exports__